module.exports = __webpack_public_path__ + "img/4.65079c4a.jpg";